import React, { useEffect } from 'react';
import { MemberExportNotice } from './MemberExportNotice';
import './MemberExportNotice.css';

interface MemberExportLockModalProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Shown instead of DataDownloadModal while MEMBER_EXPORTS_LOCKED is true.
 * TODO: Re-enable DataDownloadModal with location-based membership entitlements after conference.
 */
export const MemberExportLockModal: React.FC<MemberExportLockModalProps> = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="member-export-lock-modal__backdrop"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="member-export-lock-modal__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="member-export-lock-title"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="member-export-lock-modal__close"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        <h2 id="member-export-lock-title" className="member-export-lock-modal__title">
          Download Data
        </h2>
        <MemberExportNotice variant="panel" showDataUseNotice />
      </div>
    </div>
  );
};

export default MemberExportLockModal;
